import "../styles.css"
import vantage from '../assets/vantage.png'
import store from '../assets/store.jpg'
import sose from '../assets/sose.png'
import { SiExpress, SiCss3, SiHtml5, SiTailwindcss, SiJavascript, SiReact, SiNodedotjs, SiMongodb, SiSass, SiFirebase, SiSolidity, SiWeb3Dotjs, SiBootstrap, SiPython } from "react-icons/si";
import { LiaExternalLinkAltSolid } from "react-icons/lia";


const Works = ({ ref, lightMode }) => {
    return (
        <div ref={ref} className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
            <p className="norm-header">My Works</p>
            <div className="m-work">
                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-img">
                        <img src={vantage} alt="" />
                    </div>
                    <div className="work-desc">
                        <p className="work-catch">Stay fit</p>
                        <p className="work-name">Vantage Sports</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiBootstrap />
                            <SiReact />
                            <SiJavascript />
                            <SiMongodb />
                            <SiNodedotjs />
                            <SiFirebase />
                        </div>
                        <p className="work-exp">Private coaching and recruiting advice from current college athletes</p>
                        <a href="https://www.vantagesports.com/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                </div>

                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-img">
                        <img src={store} alt="" />
                    </div>
                    <div className="work-desc">
                        <p className="work-catch">Shop online</p>
                        <p className="work-name">Ogb Stores</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiReact />
                            <SiMongodb />
                            <SiNodedotjs />
                            <SiFirebase />
                            <SiExpress />
                            <SiJavascript />
                        </div>
                        <p className="work-exp">Shop clothes, electronics and others online</p>
                        <a href="https://ogbstores.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                </div>

                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-img">
                        <img src={sose} alt="" />
                    </div>
                    <div className="work-desc">
                        <p className="work-catch">Transfer tokens</p>
                        <p className="work-name">Red Lambo</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiReact />
                            <SiSolidity />
                            <SiWeb3Dotjs />
                            <SiJavascript />
                        </div>
                        <p className="work-exp">Connect crypto wallet and transfer tokens online</p>
                        <a href="https://sose.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                </div>
            </div>

            <div className="d-work">
                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-img">
                        <img src={vantage} alt="" />
                    </div>
                    <div className="work-desc">
                        <p className="work-catch">Stay fit</p>
                        <p className="work-name">Vantage Sports</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiBootstrap />
                            <SiReact />
                            <SiJavascript />
                            <SiMongodb />
                            <SiNodedotjs />
                            <SiFirebase />
                        </div>
                        <p className="work-exp">Private coaching and recruiting advice from current college athletes</p>
                        <a href="https://www.vantagesports.com/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                </div>

                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-desc">
                        <p className="work-catch">Shop online</p>
                        <p className="work-name">Ogb Stores</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiReact />
                            <SiMongodb />
                            <SiNodedotjs />
                            <SiFirebase />
                            <SiExpress />
                            <SiJavascript />
                        </div>
                        <p className="work-exp">Shop clothes, electronics and others online</p>
                        <a href="https://ogbstores.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                    <div className="work-img">
                        <img src={store} alt="" />
                    </div>
                </div>

                <div className={'work ' + (lightMode ? 'light-secondary' : 'dark-secondary')}>
                    <div className="work-img">
                        <img src={sose} alt="" />
                    </div>
                    <div className="work-desc">
                        <p className="work-catch">Transfer tokens</p>
                        <p className="work-name">Red Lambo</p>
                        <div className="work-langs">
                            <SiHtml5 />
                            <SiReact />
                            <SiSolidity />
                            <SiWeb3Dotjs />
                            <SiJavascript />
                        </div>
                        <p className="work-exp">Connect crypto wallet and transfer tokens online</p>
                        <a href="https://sose.vercel.app/" className="work-link"><LiaExternalLinkAltSolid style={{ fontSize: "1.5rem" }} /> <span>Live</span></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Works
